export const generateFundraiserUrl = ({
  fundraiserSlug,
  fundraiserId,
}: {
  fundraiserSlug?: string | null;
  fundraiserId?: string | null;
}): string | undefined => {
  const urlSegment = fundraiserSlug || fundraiserId;
  if (urlSegment) {
    return `https://raise.snap.app/donate/${urlSegment}`;
  }
  return;
};
